export const OAUTH_ACCOUNT_ALREADY_CONNECTED = 'PaymentAccountError.ACCOUNT_ALREADY_CONNECTED';
export const OAUTH_UNSUPPORTED_COUNTRY = 'PaymentAccountError.UNSUPPORTED_COUNTRY';